import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*-
* Stair 階段部品
*
* new AutoStair( 0,1,null,"",0,0,0);
*/
export default class AutoObjSite {
    public plgAry: Array<marietta3d.AutoGen.utils.RoomPointArray>;

    public direction: number; // 方位 0:North, +時計回り（マイナス有)

    public zoneCode: number; // 用途地域

    private mode: string;

    private area: string;

    private color: string;

    constructor() {
      this.plgAry = [];
      this.direction = 0; // 真北
      this.zoneCode = 1; // 第１種低層住居専用地域
      this.mode = '0';
      this.area = '0';
      this.color = '';
    }

    /// #################################################
    /// 敷地データ読み込み
    public readXML(site: HTMLCollection, shape: any): void {
      const rattr = site[0].attributes;
      const nodeMode = rattr.getNamedItem('mode');
      const nodeArea = rattr.getNamedItem('area');
      const nodeDir = rattr.getNamedItem('direction');
      const nodeZone = rattr.getNamedItem('zone_code');
      if (nodeMode != null) {
        this.mode = nodeMode.nodeValue;
      }
      if (nodeArea != null) {
        this.area = nodeArea.nodeValue;
      }
      if (nodeDir != null) {
        const strDir = nodeDir.nodeValue;
        if (strDir === 'NaN') {
          this.direction = 0;
        } else {
          this.direction = Number(strDir);
        }
      }
      if (nodeZone != null) {
        this.zoneCode = Number(nodeZone.nodeValue);
      }
      for (let s = 0; s < shape.length; s += 1) {
        this.plgAry.push(new marietta3d.AutoGen.utils.RoomPointArray());
        const sattr = shape[s].attributes;
        const nodeColor = sattr.getNamedItem('color');
        if (nodeColor != null) {
          this.color = nodeColor.nodeValue;
        }
        const points = shape[s].getElementsByTagName('point');
        for (let i = 0; i < points.length; i += 1) {
          const pt = points[i].attributes;
          // const idx = Number(pt.getNamedItem('index').nodeValue);
          const ptx = Number(pt.getNamedItem('x').nodeValue);
          const pty = Number(pt.getNamedItem('y').nodeValue);
          let rw = 0;
          const nodeRoad = pt.getNamedItem('road_w');
          if (nodeRoad != null) {
            rw = Number(nodeRoad.nodeValue);
          }
          this.plgAry[s].Add(new marietta.core.Point(ptx, pty, rw));
        }
      }
    }

    /// #################################################
    /// 敷地データ読み込み
    public readJson(site: any, shape: any): void {
      const nodeMode = site.mode;
      const nodeArea = site.area;
      const nodeDir = site.direction;
      const nodeZone = site.zone_code;
      if (nodeMode != null) {
        this.mode = nodeMode;
      }
      if (nodeArea != null) {
        this.area = nodeArea;
      }
      if (nodeDir != null) {
        const strDir = nodeDir;
        if (strDir === 'NaN') {
          this.direction = 0;
        } else {
          this.direction = Number(strDir);
        }
      }
      if (nodeZone != null) {
        this.zoneCode = Number(nodeZone);
      }
      for (let s = 0; s < shape.length; s += 1) {
        this.plgAry.push(new marietta3d.AutoGen.utils.RoomPointArray());
        const nodeColor = shape[s].color;
        if (nodeColor != null) {
          this.color = nodeColor;
        }
        const points = shape[s].point;
        for (let i = 0; i < points.length; i += 1) {
          const ptx = Number(points[i].x);
          const pty = Number(points[i].y);
          let rw = 0;
          const nodeRoad = points[i].road_w;
          if (nodeRoad != null) {
            rw = Number(nodeRoad);
          }
          this.plgAry[s].Add(new marietta.core.Point(ptx, pty, rw));
        }
      }
    }

    /// #################################################
    /// <summary>
    /// 敷地データ書き出し
    /// </summary>
    ///
    public WriteXML(): string {
      let xml = '';
      xml = `<site mode="${this.mode}" area="${this.area}" direction="${this.direction.toString()}" zone_code="${this.zoneCode.toString()}">\n`;
      for (let s = 0; s < this.plgAry.length; s += 1) {
        xml = `${xml}<shape index="${(s + 1).toString()}" createindex="${(s + 1).toString()}" color="${this.color}">\n`;
        for (let i = 0; i < this.plgAry[s].length; i += 1) {
          const p = this.plgAry[s][i];
          const num = (i + 1).toString();
          xml = `${xml}<point index="${num}" x="${p.x.toString()}" y="${p.y.toString()}" road_w="${p.flag.toString()}"/>\n`;
        }
        xml += '</shape>\n';
      }
      xml += '</site>\n';
      return xml;
    }

    /// #################################################
    /// <summary>
    /// 敷地データ書き出し
    /// </summary>
    ///
    public WriteXML2(doc: Document, plan: Element): void {
      const nodeSite = doc.createElement('site');
      plan.appendChild(nodeSite);
      nodeSite.setAttribute('mode', this.mode);
      nodeSite.setAttribute('area', this.area);
      nodeSite.setAttribute('direction', this.direction.toString());
      nodeSite.setAttribute('zone_code', this.zoneCode.toString());
      for (let s = 0; s < this.plgAry.length; s += 1) {
        const nodeShape = doc.createElement('shape');
        nodeSite.appendChild(nodeShape);
        nodeShape.setAttribute('index', (s + 1).toString());
        nodeShape.setAttribute('createindex', (s + 1).toString());
        nodeShape.setAttribute('color', this.color);
        for (let i = 0; i < this.plgAry[s].length; i += 1) {
          const nodePt = doc.createElement('point');
          nodeShape.appendChild(nodePt);
          const p = this.plgAry[s][i];
          const num = (i + 1).toString();
          nodePt.setAttribute('index', num);
          nodePt.setAttribute('x', p.x.toString());
          nodePt.setAttribute('y', p.y.toString());
          nodePt.setAttribute('road_w', p.flag.toString());
        }
      }
    }
}
